const defaultPicture = 'https://d2nce6johdc51d.cloudfront.net/img/profile-icon.svg'

export function getSurveyImageSrc(fileName: string) {
  return `${process.env.S3_ROOT}/${fileName}`
}

export function getProfileSrc(fileName: string) {
  if (!fileName) return defaultPicture

  return `${process.env.IMAGE_ROOT}/w128-h128-c/${process.env.IMAGE_PREFIX}/${fileName}`
}

export function resizeImage(src: string, size = 'w120-h120-c') {
  const S3_ROOT = process.env.S3_ROOT || ''
  if (typeof src !== 'string') return ''
  const S3_BASE = S3_ROOT.replace('/survey', '')
  return `${process.env.IMAGE_ROOT}/${size}${src.replace(S3_BASE, '')}`
}
